module.exports = __webpack_public_path__ + "static/media/friends-attending.c9ce4939.svg";